import {
  queryModelData as publicQueryModelData,
  getModel as publicGetModel,
  listModels as publicListModels,
} from './analytics-model-v3-model-analytics-model.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const queryModelData: MaybeContext<
  BuildRESTFunction<typeof publicQueryModelData> & typeof publicQueryModelData
> = /*#__PURE__*/ createRESTModule(publicQueryModelData);
export const getModel: MaybeContext<
  BuildRESTFunction<typeof publicGetModel> & typeof publicGetModel
> = /*#__PURE__*/ createRESTModule(publicGetModel);
export const listModels: MaybeContext<
  BuildRESTFunction<typeof publicListModels> & typeof publicListModels
> = /*#__PURE__*/ createRESTModule(publicListModels);

export {
  ModelFilterPrefixEnum,
  ModelFilterConditionEnum,
  ModelFieldTypeEnum,
  FieldVisibilityEnum,
  SortOrder,
  CacheControlEnum,
  CacheSatusEnum,
} from './analytics-model-v3-model-analytics-model.universal.js';
export {
  SemanticModel,
  Model,
  ModelFieldValue,
  ModelFieldValueValueOneOf,
  ModelFieldFilters,
  ModelField,
  QueryModelDataRequest,
  DateTimeInterval,
  Sorting,
  FieldFilter,
  Paging,
  Control,
  QueryModelDataResponse,
  ModelFieldDataRow,
  Status,
  PagingMetadata,
  GetModelRequest,
  GetModelResponse,
  ListModelsRequest,
  ListModelsResponse,
  QueryModelDataOptions,
} from './analytics-model-v3-model-analytics-model.universal.js';
export {
  ModelFilterPrefixEnumWithLiterals,
  ModelFilterConditionEnumWithLiterals,
  ModelFieldTypeEnumWithLiterals,
  FieldVisibilityEnumWithLiterals,
  SortOrderWithLiterals,
  CacheControlEnumWithLiterals,
  CacheSatusEnumWithLiterals,
  QueryModelDataApplicationErrors,
  GetModelApplicationErrors,
  ListModelsApplicationErrors,
} from './analytics-model-v3-model-analytics-model.universal.js';
